// extracted by mini-css-extract-plugin
export default {"btn_dark":"Project_btn_dark__xWLb3","btn_light":"Project_btn_light__ii-dc"};